<template>
	<div>
		<div class="btn-box flex-row-align-center pb-24">
			<el-button @click="addTag">添加标签</el-button>
			<p class="yx-color-text-primary ml-16 font-h4-regular">
				共
				<span class="yx-color-primary">{{ total }}</span>
				个标签
			</p>
		</div>
		<multi-table
			v-loading="loading"
			:page="pageInfo"
			@gePartnerList="gePartnerList" 
			:total="total"
			ref="multiTable"
			:columns="columns"
			:list="list"
		>
			<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
		</multi-table>

		<add-tag ref="addTag" @refreshList="refreshList" />
		<edit-tag ref="editTag" @refreshList="refreshList" />
		<del-dialog ref="del" @refreshList="refreshList" />
	</div>
</template>
<script>
import { getTagList } from '@/api/tagManagement';
import empty from '@/views/common/empty/index.vue';
import getColumns from './columns';

export default {
	components: {
		AddTag: () => import('./addTag.vue'),
		editTag: () => import('./editTag.vue'),
		delDialog: () => import('./delTag.vue'),
		empty
	},
	data() {
		return {
			list: [],
			isSearch: false,
			loading: false,
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			total: 0,
			params: {},
		};
	},
	computed: {
		columns() {
			return getColumns(this);
		},  
	},
	methods: {
		gePartnerList(val) {
			this.pageInfo.page_index = val.page_index;
			this.pageInfo.page_size = val.page_size;
			this.getList();
		},
		async getList(isSearch) {
			this.isSearch = Boolean(isSearch);
			this.loading = true;
			let { page_index:pageIndex, page_size: pageSize } = this.pageInfo;
			const { data }  = await getTagList({ pageIndex, pageSize, ...this.params,appType: 1 });
			this.loading = false;
			this.total = `${data.page.itemTotal}`;
			this.list = data.list.map(item => {
				item.operations = this.getButtons(item);
				return item;
			});
		},
		getButtons(item) {
			const arr = [];
			arr.push(
				{
					label: '编辑',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: () => this.edit(item),
				},
				{
					label: '删除',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: () => this.del(item),
				},
			);
			return arr.filter(item => item.isShow);
		},
		addTag() {
			this.$refs.addTag.show();
		},
		edit(row) {
			this.$refs.editTag.show(row);
		},
		del({ id }) {
			this.$refs.del.show(id);
		},
		refreshList() {
			this.getList();
		},
		onSubmit(val) {
			this.pageInfo.page_index = 1;
			this.params = val;
			this.getList(1);
		},
	},
};
</script>
<style lang="less" scoped></style>
